import { createSelector } from "@reduxjs/toolkit";
import { selectUnreviewedDraftsCount } from "./performersSlice";

/**
 * Nav item key that shows unreviewed performer drafts count.
 */
const PERFORMERS_NAV_KEY = "pagePerformers";

const NAV_ITEM_KEYS = [
  "pagePerformers",
  "pageEvents",
  "pageOrders",
  "pageShows",
  "pageRooms",
  "pageDashboard",
];

/**
 * Returns the badge count for a nav item. Only Performers shows a count (unreviewed drafts).
 */
export const selectBadgeForNavItem = createSelector(
  [
    (state, args) => args?.navItemKey,
    (state) => state,
  ],
  (navItemKey, state) => {
    if (navItemKey === PERFORMERS_NAV_KEY) {
      return selectUnreviewedDraftsCount(state);
    }
    return 0;
  },
);

/** Badge count for every nav item key. Use in nav to avoid N useSelectors in a loop. */
export const selectAllNavBadges = createSelector(
  [(state) => selectUnreviewedDraftsCount(state)],
  (unreviewedDraftsCount) => {
    const result = {};
    NAV_ITEM_KEYS.forEach((navItemKey) => {
      result[navItemKey] =
        navItemKey === PERFORMERS_NAV_KEY ? unreviewedDraftsCount : 0;
    });
    return result;
  },
);
